var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportsWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.05,
    height: 19.042,
    viewBox: "0 0 19.05 19.042",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160668",
    "data-name": "Group 160668",
    transform: "translate(-368.631 -416.631)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160574",
    "data-name": "Group 160574",
    transform: "translate(369 417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Reports_Outline_24px",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1126",
    "data-name": "Rectangle 1126",
    width: 18,
    height: 18,
    transform: "translate(0)",
    fill: "#ffecd4",
    opacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_986",
    width: 18,
    height: 18,
    transform: "translate(0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    d: "M9.169,5.28a7.309,7.309,0,1,0,7.309,7.309H9.169Z",
    transform: "translate(-1.479 -1.975)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    d: "M17.528,3.042a7.267,7.267,0,0,0-3.9-1.122h0V9.229h7.309a7.264,7.264,0,0,0-.931-3.568",
    transform: "translate(-3.008 -1.539)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_152",
    "data-name": "Ellipse 152",
    cx: 0.496,
    cy: 0.496,
    r: 0.496,
    transform: "translate(15.399 2.313)",
    fill: "#787f88"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsWhiteIcon);
export default __webpack_public_path__ + "static/media/reports-white-icon.2f2f40219c5411f16649c42250b5db11.svg";
export { ForwardRef as ReactComponent };